import {mapGetters} from 'vuex';
import mvtMarketTrendsCTA from '@/common/components/mvtmarkettrendscta/mvt-markettrendscta.vue';

export default {
    name: 'marketOverview',
    components: {
        mvtMarketTrendsCTA
    },
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['geo', 'getMarketInfo','getGeoPath','getGeoDisplayText']),
        sectionVisibility() {
            const marketInfo = this.getMarketInfo;
            return this.getGeoPath && marketInfo && (marketInfo.homeForSaleCount || marketInfo.homeNewCount || marketInfo.homeOpenCount || marketInfo.medianPricePerSqft);
        },
        saveSearch(){
            this.$eventBus.$emit('eventbus-save-search');
        },
        getMapSearchLinks() {
            return this.generateMapSearchUrl(this.glb.appUrl, {
                type: this.geo.neighborhood ? 'neighborhood' : (this.geo.zipcode ? 'zipcode' : 'city'),
                cityName: this.geo.city,
                stateCode: this.geo.stateCode,
                zipcode: this.geo.zipcode,
                neighborhood: this.geo.neighborhood,
                filterArray: ['openHouse', 'new', 'priceReduce'],
                listingCountObj: this.glb.listingCountObj,
                rentals: this.glb.rentals
            });
        }
    }
}
